module.exports = __webpack_public_path__ + "img/send-24px.svg";